import { render, staticRenderFns } from "./index.component.vue?vue&type=template&id=3cb85da3"
import script from "./index.component.js?vue&type=script&lang=js&external"
export * from "./index.component.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports